import { ROUTES_TRANSLATIONS } from "./routes-translate";
import { PT_BR_TRANSLATIONS } from "./pt-BR";
import { EN_US_TRANSLATIONS } from "./en-US";
import { ES_ES_TRANSLATIONS } from "./es-ES";

export const TRANSLATIONS = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'pt-BR': { ...ROUTES_TRANSLATIONS, ...PT_BR_TRANSLATIONS },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'en-US': { ...ROUTES_TRANSLATIONS, ...EN_US_TRANSLATIONS },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'es-ES': { ...ROUTES_TRANSLATIONS, ...ES_ES_TRANSLATIONS },
};
